var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classNames from 'classnames';
import * as React from 'react';
import { ConfigContext } from '../config-provider';
const MenuList = (_a) => {
    var { prefixCls: customizePrefixCls, className, prefixIcon, suffixIcon, title, onClick } = _a, restProps = __rest(_a, ["prefixCls", "className", "prefixIcon", "suffixIcon", "title", "onClick"]);
    const { getPrefixCls } = React.useContext(ConfigContext);
    const handleClick = (e) => {
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    const prefixCls = getPrefixCls('menu-list', customizePrefixCls);
    return (React.createElement("span", Object.assign({}, restProps, { className: classNames(`${prefixCls}`, className), onClick: handleClick }),
        React.createElement("div", { className: classNames(`${prefixCls}-item`) },
            prefixIcon && React.createElement("div", { className: `${prefixCls}-prefix-icon` }, prefixIcon),
            title && React.createElement("div", { className: `${prefixCls}-title` }, title),
            suffixIcon && React.createElement("div", { className: `${prefixCls}-suffix-icon` }, suffixIcon))));
};
if (process.env.NODE_ENV !== 'production') {
    MenuList.displayName = 'MenuList';
}
export default MenuList;
